<template>
  <transition name="fade" v-on:after-enter="afterEnter" v-on:before-leave="beforeLeave">
    <div v-on-click-outside.static="closeDropdown" v-show="showOptions" class="dropdown-content db f7 w4 right-0"
         :class="{'track-options': inPlayer, 'top-2': !inPlayer, 'absolute': !inMyLikes}">
      <button @click.stop="addTrackToQueue" class="pv2 bn pointer tl w-100 flex justify-between" :class="{'displayNone': inMyLikes}">
        {{ $t("tracks.actions.addToQueue") }}
        <font-awesome-icon class="iconColor" icon="plus"/>
      </button>
      <button v-show="!antelPublicUser && !bitelFreeMusic" @click.stop="buyTrack" class="pv2 bn pointer tl w-100 flex justify-between">{{ $t("tracks.actions.buy")
        }}
        <font-awesome-icon class="iconColor" icon="arrow-down"/>
      </button>
      <button v-if="!inPlayer" v-show="!antelPublicUser" @click.stop="like" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.like") }}
        <font-awesome-icon :class="{'isLiked': isLiked || track.like, 'iconColor': !isLiked}" icon="heart"/>
      </button>
      <button @click.stop="shareTrack" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.share") }}
        <font-awesome-icon class="iconColor" icon="share-alt"/>
      </button>
      <button v-show="isMyTrack" @click.stop="deleteTrack" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("app.delete") }}
        <font-awesome-icon class="iconColor" icon="trash"/>
      </button>
      <router-link :to="{name: 'track-edit', params: {id: track.id}}" v-show="isMyTrack"
                   class="iconColor no-underline pa2 pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.edit") }}
        <font-awesome-icon class="iconColor" icon="edit"/>
      </router-link>
      <button v-show="!antelPublicUser" @click.stop="addTrackToPlaylist" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.addToPlaylist") }}
        <font-awesome-icon class="iconColor" icon="indent"/>
      </button>
      <button v-show="playlist && canRemoveTracks" @click.stop="deleteFromPlaylist" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.deleteFromPlaylist") }}
        <font-awesome-icon class="iconColor" icon="minus-circle"/>
      </button>
      <button  @click.stop="creditsView" class="pa2 bn pointer tl w-100 flex justify-between">
        {{ $t("tracks.actions.credits") }}
        <font-awesome-icon class="iconColor" icon="bars"/>
      </button>
    </div>
  </transition>
</template>


<script>
  import { mapGetters, mapActions } from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import { mixin as onClickOutside } from 'vue-on-click-outside'
  import consts from '@/consts'
  import Vue from 'vue'

  Vue.component('multiline-text', {
    props: ['text'],
    template: `
      <div>
        <p v-for="line in text.split('\n')">{{ line }}</p>
      </div>
    `
})

  export default {
    name: 'track-options',
    props: {
      track: {
        require: true
      },
      inPlayer: {
        default: false
      },
      showOptions: {
        default: false
      },
      playlist: {
        default: null
      },
      inMyLikes: {
        default: false
      }
    },
    data () {
      return {
        host: consts.BASE_HOST,
        transitionVisible: false,
        antelPublicUser: false,
        isLiked: false,
        canRemoveTracks: false,
        bitelFreeMusic: false
      }
    },
    components: {
      FontAwesomeIcon
    },
    mixins: [onClickOutside],
    computed: {
      ...mapGetters('player', [
        'currentTrack'
      ]),
      ...mapGetters('user', [
        'myTracks',
        'isSubscribed',
        'isLoggedIn',
        'user'
      ]),
      isMyTrack () {
        return this.myTracks.includes(this.track)
      },
      picture () {
        return consts.API_BASE_URL + this.track.path + this.track.picture
      }
    },
    mounted () {
      if (this.playlist) {
        if (this.playlist.user.id === this.user.id) {
          this.canRemoveTracks = true
        }
      }
      if (this.inPlayer) {
        this.isLiked = this.currentTrack.is_liked
      } else if (this.$route.name === 'my-favorites') {
        this.isLiked = true
      } else {
        if (this.track.is_liked || this.track.like) {
          this.isLiked = true
        }
      }
      let msisdn = localStorage.getItem('msisdn')
      if (msisdn && msisdn === 'PublicUser') {
        this.antelPublicUser = true
      } else {
        this.antelPublicUser = false
      }
      if (msisdn && msisdn === 'freeMusic') {
        this.bitelFreeMusic = true
      } else {
        this.bitelFreeMusic = false
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'setCurrentIndexOfPlaylist',
        'addToQueue',
        'setCurrentTrackLike'
      ]),
      ...mapActions('track', [
        'setLike',
        'delete'
      ]),
      ...mapActions('playlist', [
        'deleteTrackFromPlaylist',
        'getPlaylist'
      ]),
      ...mapActions('user', [
        'getMyFavorites'
      ]),
      addTrackToQueue () {
        this.addToQueue(this.track)
        this.closeDropdown()
      },
      checkUserState () {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
          return false
        } else if (!this.isSubscribed) {
          this.$modal.show('subscription-modal')
          return false
        } else {
          return true
        }
      },
      buyTrack () {
        this.$modal.show('buy-track-modal', {track: this.track})
        this.closeDropdown()
      },
      shareTrack () {
        this.$modal.show('share-modal', {
          link: this.host + '/services/share/track/' + this.track.id,
          title: this.track.title,
          description: this.track.name,
          track: this.track
        })
        this.closeDropdown()
      },
      like () {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
        } else {
          this.setLike(this.track.id).then((item) => {
            if (this.track.id === this.currentTrack.id) {
              this.setCurrentTrackLike(this.isLiked !== true).then(() => {
                this.isLiked = this.isLiked !== true
              })
            } else {
              this.isLiked = this.isLiked !== true
            }
            this.getMyFavorites({genreIdFilter: 0, textToFilter: null}).catch((e) => {
              this.$toasted.show(this.error.message, {type: 'error'})
            })
            this.closeDropdown()
          })
        }
      },
      deleteTrack () {
        this.$modal.show('dialog', {
          title: this.$t('tracks.deleteTrack.title'),
          text: this.$t('tracks.deleteTrack.confirm'),
          buttons: [
            {
              title: this.$t('app.yes'),
              handler: () => {
                this.delete(this.track.id).then(() => {
                  this.closeDropdown()
                  this.$toasted.show(this.$t('tracks.deleteTrack.success'), {type: 'success'})
                }).catch((e) => {
                  this.$toasted.show(this.error.message, {type: 'error'})
                })
                this.$modal.hide('dialog')
              }
            },
            {
              title: this.$t('app.no'),
              default: true,
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },
      addTrackToPlaylist () {
        // if (this.checkUserState()) {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
        } else {
          this.$modal.show('add-to-playlist-modal', {track: this.track})
        }
        // }
      },
      deleteFromPlaylist () {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
        } else {
          this.$modal.show('dialog', {
            title: this.$t('playlists.deleteTrackFromPlaylist.title'),
            text: this.$t('playlists.deleteTrackFromPlaylist.confirm'),
            buttons: [
              {
                title: this.$t('app.yes'),
                handler: () => {
                  this.deleteTrackFromPlaylist({trackId: this.track.id, playlistId: this.playlist.id}).then(() => {
                    this.closeDropdown()
                    this.$toasted.show(this.$t('playlists.deleteTrackFromPlaylist.success'), {type: 'success'})
                  }).catch((e) => {
                    this.$toasted.show(e, {type: 'error'})
                  })
                  this.$modal.hide('dialog')
                }
              },
              {
                title: this.$t('app.no'),
                default: true,
                handler: () => {
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        }
      },
      closeDropdown () {
        if (this.transitionVisible && this.showOptions) {
          this.$emit('close-dropdown')
        }
      },
      afterEnter () {
        this.transitionVisible = true
      },
      beforeLeave () {
        this.transitionVisible = false
      },
      creditsView () {
        this.$modal.show('credits-modal', {
          credits: this.track.credits
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .dropdown-content {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    z-index: 10;
    background-color: $background-color !important;
    button {
      color: $text-color;
      background-color: $background-color !important;
    }
    a {
      background-color: $background-color;
    }
  }

  .track-options {
    position: fixed;
    bottom: 50px;
    right: 8rem;
  }

  .dropdown-content button:hover {
    background-color: $primary-color !important;
  }

  .dropdown-content a:hover {
    background-color: $primary-color !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .isLiked {
    color: red;
  }

  .displayNone {
    display: none;
  }

  @media screen and (max-width: 479px) {
    .track-options {
      right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackOptions.vue